import React from "react";
import GoodBetterBestBanner from "~/ProductDetails/SpotlightBanner/GoodBetterBest";
import SideBySideBanner from "~/ProductDetails/SpotlightBanner/SideBySide";
import { BannerType } from "~/ProductDetails/SpotlightBanner/shared/definitions";
import { ProductDetailPageResult } from "../ProductDetailPageResult";
import { defaultUserObject } from "~/common/Store/rootReducer";
import { useDoNotShowGBB } from "./hooks/useDoNotShowGbb";
interface SpotlightBannerProps {
  activeTemplate: ProductDetailPageResult | undefined;
  setShowSpotlightBanner: React.Dispatch<React.SetStateAction<boolean>>;
}
const getBannerType = (showGoodBetterBestBanner?: boolean, hasSideBySideProductCompare?: boolean): string => {
  if (hasSideBySideProductCompare) {
    return BannerType.SideBySide;
  }
  if (showGoodBetterBestBanner) {
    return BannerType.GoodBetterBest;
  }
  return "";
};
export const SpotlightBanner = ({
  activeTemplate,
  setShowSpotlightBanner
}: Readonly<SpotlightBannerProps>) => {
  const doNotShowGBB = useDoNotShowGBB();
  if (!activeTemplate) return null;
  const {
    itemNumber,
    showGoodBetterBestBanner,
    sideBySideProductCompareItem
  } = activeTemplate;
  const bannerType = getBannerType(showGoodBetterBestBanner && !doNotShowGBB, sideBySideProductCompareItem?.hasSideBySideProductCompare);
  if (!bannerType) return null;
  if (bannerType === BannerType.GoodBetterBest) {
    return <GoodBetterBestBanner itemNumber={itemNumber} toggleSpotlightBanner={(enabled: boolean) => setShowSpotlightBanner(enabled)} user={defaultUserObject} mounted />;
  }
  const hideSideBySideBanner = sideBySideProductCompareItem?.displayType === "U" && !sideBySideProductCompareItem?.isRecommendedSimilarItem;
  if (bannerType === BannerType.SideBySide && !hideSideBySideBanner) {
    return <SideBySideBanner originalLinkingItemNumber={itemNumber} sideBySideProductCompareItem={sideBySideProductCompareItem} user={defaultUserObject} mounted />;
  }
  return null;
};